export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center">
      <div className="absolute inset-0 flex">
        <div className="w-full lg:w-1/2 bg-background-50"></div>
        <div className="hidden lg:block lg:w-1/2 relative overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Soft%20warm%20artistic%20fashion%20product%20photography%20with%20minimalist%20aesthetic%2C%20cream%20and%20beige%20neutral%20background%20with%20gentle%20natural%20lighting%2C%20elegant%20fashion%20items%20displayed%20on%20simple%20surfaces%2C%20editorial%20composition%20with%20organic%20textures%2C%20soft%20shadows%2C%20Scandinavian%20minimalist%20vibe%2C%20warm%20ambient%20tone%2C%20no%20harsh%20colors%2C%20peaceful%20and%20clean%20product%20display&width=1400&height=1800&seq=hero-bg-main-01&orientation=portrait"
            alt="YOYBUY Spreadsheet shopping guide"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-100/40 to-transparent"></div>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="lg:w-1/2 lg:pr-16 pt-32 md:pt-40 pb-20 md:pb-32">
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-foreground-400 font-medium mb-6 bg-background-100 px-4 py-2 rounded-full">
            Руководство 2026
          </span>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-foreground-950 font-semibold leading-[1.08] mb-6">
            YOYBUY Sheet
            <br />
            <span className="text-foreground-600 font-light italic">
              Полное руководство
            </span>
          </h1>
          <p className="text-foreground-500 text-base md:text-lg leading-relaxed max-w-lg mb-10">
            Ваш надёжный гид по использованию YOYBUY Spreadsheet. Найдите лучшие категории товаров, изучите все возможности платформы и начните экономить уже сегодня.
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="bg-foreground-950 text-background-50 px-8 py-4 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              YOYBUY Sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="border-2 border-foreground-900 text-foreground-900 px-8 py-4 rounded-full text-sm font-semibold hover:bg-foreground-900 hover:text-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Купить сейчас
              <i className="ri-shopping-bag-3-line"></i>
            </a>
          </div>

          <div className="mt-16 flex items-center gap-8">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-check-line text-accent-600 text-lg"></i>
              </div>
              <span className="text-sm text-foreground-600">14 категорий</span>
            </div>
            <div className="w-px h-8 bg-background-300"></div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-shield-check-line text-accent-600 text-lg"></i>
              </div>
              <span className="text-sm text-foreground-600">Безопасно</span>
            </div>
            <div className="w-px h-8 bg-background-300"></div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-flashlight-line text-accent-600 text-lg"></i>
              </div>
              <span className="text-sm text-foreground-600">Быстрый доступ</span>
            </div>
          </div>
        </div>
      </div>

      <div className="lg:hidden absolute inset-0 -z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20warm%20minimalist%20fashion%20background%20with%20cream%20beige%20tones%2C%20product%20photography%20style%20with%20gentle%20shadows%2C%20neutral%20aesthetic%2C%20organic%20textures%2C%20peaceful%20clean%20composition%2C%20warm%20ambient%20lighting&width=800&height=1200&seq=hero-bg-mobile-01&orientation=portrait"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-background-50/85"></div>
      </div>
    </section>
  );
}